import Loading from './loading'

export default {
  install (Vue) {
    Vue.directive('load', Loading)
  }
}


// WEBPACK FOOTER //
// ./src/directive/index.js